/**
 * @file 権限切り替えモーダル管理
 */

'use strict';

/**
 * @classname ChangeLevelModal
 * @classdesc 権限切り替えモーダル管理
 */
export default class ChangeLevelModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`ChangeLevelModal.constructor`);
		this._modalElement = document.getElementById('modal-change-level');
		this._$councilId = $(this._modalElement).find('.council_id')
		this.setEvent();
	}


	/**
	 * イベントをセット
	 *
	 * @memberof ChangeLevelModal
	 * @return {undefined}
	 */
	setEvent() {
		console.log(`ChangeLevelModal.setEvent`);
		this._modalElement.addEventListener('shown.bs.modal', () => this._$councilId.removeClass('ignore-validate'));
		this._modalElement.addEventListener('hidden.bs.modal', () => {
			this._$councilId
				.removeClass('ignore-validate is-invalid')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
		});
	}
}
